module.exports = __webpack_public_path__ + "static/img/3.d3087e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/laboratory/3.jpg
// module id = UKhd
// module chunks = 1